const STANDARD = 'standard';
const METRIC = 'metric';

const FT_PER_METER = 3.28084;
/* eslint-disable no-restricted-properties */
const cuFtToCuM = cuft => cuft / Math.pow(FT_PER_METER, 3);
const cuMToCuFt = cum => cum * Math.pow(FT_PER_METER, 3);
const sqFtToSqM = cuft => cuft / Math.pow(FT_PER_METER, 2);
const sqMToSqFt = cum => cum * Math.pow(FT_PER_METER, 2);
const cuyToCum = cuy => cuy / Math.pow(FT_PER_METER / 3, 3);
const cumToCuy = cum => cum * Math.pow(FT_PER_METER / 3, 3);
/* eslint-enable no-restricted-properties */

const KM_PER_MI = 1.60934;
const miToKm = mi => (mi * KM_PER_MI);
const kmToMi = km => (km / KM_PER_MI);

const LT_PER_GAL = 3.785411784;
const galToLt = gal => gal * LT_PER_GAL;
const ltToGal = lt => lt / LT_PER_GAL;

const fuelEfficiencyUnit = t => (isMetric, isElectric) => {
  if (isElectric && isMetric) return t('kWh/100km', { ns: 'units' });
  if (isElectric && !isMetric) return t('kWh/100mi', { ns: 'units' });
  if (!isElectric && isMetric) return t('L/100km', { ns: 'units' });
  return t('mpg', { ns: 'units' });
};

const fuelConsumptionUnit = t => (isMetric, isElectric) => {
  if (isElectric) return t('kWh');
  if (isMetric) return t('L');
  return t('gal');
};

const LBS_PER_KG = 2.20462;
const lbsToKg = lbs => lbs / LBS_PER_KG;
const kgToLbs = kg => kg * LBS_PER_KG;
const lbsPerGalToKgPerL = lbsPerGal => (lbsPerGal / LBS_PER_KG) / LT_PER_GAL;

const SHORT_TON_PER_METRIC_TON = 1.10231;
const shortToMetricTon = st => st / SHORT_TON_PER_METRIC_TON;
const metricToShortTon = mt => mt * SHORT_TON_PER_METRIC_TON;

const KWH_PER_GGE = 33.40; // kwh per gallons gasoline equivalent
const kwhPer100MiToMpge = kwhPer100Mi => (KWH_PER_GGE / kwhPer100Mi) * 100;
const kwhPer100KmToMpge = kwhPer100Km => (KWH_PER_GGE / (kwhPer100Km * KM_PER_MI)) * 100;
const mpgToLtPer100Km = mpg => (LT_PER_GAL / (mpg * KM_PER_MI)) * 100;
const ltPer100KmToMpg = ltPer100Km => (LT_PER_GAL / (ltPer100Km * KM_PER_MI)) * 100;

const convertToMpge = (efficiency, isMetric, isElectric) => {
  if (!isElectric && !isMetric) return efficiency;
  if (isElectric) {
    if (isMetric) {
      return kwhPer100KmToMpge(efficiency);
    }
    return kwhPer100MiToMpge(efficiency);
  }
  return ltPer100KmToMpg(efficiency);
};

const convertFuelEfficiencyToStandard = (efficiency, isMetric, isElectric) => {
  if (!isMetric) return efficiency;
  if (isElectric) return efficiency * KM_PER_MI;
  return ltPer100KmToMpg(efficiency);
};

const convertFuelEfficiencyToMetric = (efficiency, isMetric, isElectric) => {
  if (isMetric) return efficiency;
  if (isElectric) return efficiency / KM_PER_MI;
  return mpgToLtPer100Km(efficiency);
};

const farenheitToCelsius = farenheit => (farenheit - 32) * (5 / 9);
const celsiusToFarenheit = celsius => (celsius * (9 / 5)) + 32;
const farenheitToCelsiusDiff = farenheit => farenheit * (5 / 9);
const celsiusToFarenheitDiff = celsius => celsius * (9 / 5);

const NATURAL_GAS_CUBIC_METERS_TO_THERMS = 2.83;
const naturalGasThermsToCubicMeters = therms => therms * NATURAL_GAS_CUBIC_METERS_TO_THERMS;
const naturalGasCubicMetersToTherms =
  cubicMeters => cubicMeters / NATURAL_GAS_CUBIC_METERS_TO_THERMS;

export default {
  STANDARD,
  METRIC,
  isMetric: unitSystem => unitSystem === METRIC,
  isStandard: unitSystem => unitSystem === STANDARD,
  KWH_PER_GGE,
  LT_PER_GAL,
  KM_PER_MI,
  FT_PER_METER,
  SHORT_TON_PER_METRIC_TON,
  kmToMi,
  miToKm,
  galToLt,
  lbsToKg,
  kgToLbs,
  shortToMetricTon,
  metricToShortTon,
  ltToGal,
  ltPer100KmToMpg,
  mpgToLtPer100Km,
  convertToMpge,
  convertFuelEfficiencyToStandard,
  convertFuelEfficiencyToMetric,
  fuelConsumptionUnit,
  fuelEfficiencyUnit,
  cuFtToCuM,
  cuMToCuFt,
  cuyToCum,
  cumToCuy,
  farenheitToCelsius,
  celsiusToFarenheit,
  farenheitToCelsiusDiff,
  celsiusToFarenheitDiff,
  sqFtToSqM,
  sqMToSqFt,
  lbsPerGalToKgPerL,
  naturalGasThermsToCubicMeters,
  naturalGasCubicMetersToTherms,
};
